import formater from './index'

export const DEFAULT_FORMAT = {
  ENUM: 'enum',
  DATE: 'date',
  CURRENCY: 'currency',
  NUMBER: 'number'
}

export default {
  enum: (dictName:string) => {
    return ({ text }: any) => {
      return formater.dictFormatter(text, dictName)
    }
  },

  date: () => {
    return ({ text }: any) => {
      return formater.dateFormatter(text)
    }
  },

  currency: () => {
    return ({ text }: any) => {
      return formater.numberFormatter(text, 2, false)
    }
  },

  // OPTIMIZE
  number: () => {
    return ({ text }: any) => {
      return formater.numberFormatter(text, 2, false)
    }
  }
}
